import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultLegalContent: PageTypeContentModule = {
  pageTypeSlug: "legal",
  suggestedTitles: ["Terms of Service", "Privacy Policy", "Refund Policy", "Cookie Policy"],
  suggestedSlugs: ["terms-of-service", "privacy-policy", "refund-policy", "cookie-policy"],
  description: "Legal documents, terms, and policies",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Terms of Service", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "Please read these Terms of Service carefully before using our website and services. By accessing or using our platform, you agree to be bound by these terms.",
        },
      },
      {
        type: "header",
        data: { text: "Acceptable Use", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "You agree to use our services in accordance with all applicable laws and regulations. You will not engage in any activity that interferes with or disrupts the functioning of our platform.",
        },
      },
      {
        type: "header",
        data: { text: "Intellectual Property", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "All content, trademarks, and other intellectual property on this website are owned by us or our licensors. You may not reproduce, distribute, or modify any content without our prior written consent.",
        },
      },
      {
        type: "header",
        data: { text: "Limitation of Liability", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Our services are provided 'as is' without any warranties. We shall not be liable for any indirect, incidental, or consequential damages arising from your use of our platform.",
        },
      },
      {
        type: "header",
        data: { text: "Contact Information", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "If you have any questions about these Terms of Service, please contact us at legal@example.com.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
